import React from "react";

import { faPhone } from "@fortawesome/pro-solid-svg-icons/faPhone";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import parsePhoneNumber from "@mapmycustomers/shared/util/phone/parsePhoneNumber";
import { TextField, TextFieldProps } from "@mapmycustomers/ui";

import styles from "./TextFieldWithLink.module.scss";

const PhoneTextField = (props: TextFieldProps) => {
  const value = props.value ? String(props.value) : "";
  const parsedPhoneNumber = parsePhoneNumber(value);
  const isValidPhone = !!parsedPhoneNumber;

  return (
    <TextField
      {...props}
      suffix={
        <a href={parsedPhoneNumber?.link}>
          {isValidPhone && (
            <div className={styles.textFieldIcon}>
              <FontAwesomeIcon className={styles.iconColor} icon={faPhone} />
            </div>
          )}
        </a>
      }
    />
  );
};

export default PhoneTextField;
